module.exports = __webpack_public_path__ + "static/img/1@2x.f24faff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/1@2x.png
// module id = D/bE
// module chunks = 1